/*eslint-disable eqeqeq */
/*eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import GenericButton from '../../../../../../Components/GenericButton/GenericButton';
import { t } from 'i18next';

const AffiliationsAwardsAccordion = ({
  affiliatedDoctorsHandler,
  doctorDetails,
  ...otherProps
}) => {
  const [medicalGroups, setMedicalGroups] = useState([]);
  const [affiliatedFacilities, setAffiliatedFacilities] = useState([]);
  useEffect(() => {
    if (
      doctorDetails.DoctorAfflFacilities &&
      doctorDetails.DoctorAfflFacilities.length
    ) {
      const meidicalGroupInfo = [];
      const afflFacilityInfo = [];
      doctorDetails.DoctorAfflFacilities.map((item, index) => {
        if (item.FacilityType == 'Group') {
          meidicalGroupInfo.push(item);
        } else {
          afflFacilityInfo.push(item);
        }
      });
      setMedicalGroups(meidicalGroupInfo);
      setAffiliatedFacilities(afflFacilityInfo);
    }
  }, [doctorDetails]);

  return (
    <>
      <div className="provider-professional-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.affiliations')}
          </p>
          <Col sm={12} className="p-0">
            <p className="provider-affiliation-sub-heading mb-0">
              {t('find_provider.hospitals_and_facilities')}
            </p>
            <Row>
              {affiliatedFacilities && affiliatedFacilities.length ? (
                affiliatedFacilities.map((item, index) => (
                  <Col sm={6} className="mt-3" key={index}>
                    <p className="provider-details-sub-heading">
                      {item.FacilityName}
                    </p>
                    <p className="provider-details-data-secondary">
                      <span className="provider-details-data">
                        {item.AddressLine1 && item.AddressLine1 + ', '}
                        {item.AddressLine2 && item.AddressLine2 + ', '}
                        {item.AddressLine3 && item.AddressLine3 + ', '}
                        {item.City && item.City + ', '} <br />
                        {item.County && item.County + ', '}
                        {item.State && item.State + ', '}
                        {item.PostalCode && item.PostalCode} |{' '}
                      </span>
                    </p>
                    <GenericButton
                      className=" p-0 m-0 paragraph-font secondary-2 provider-location-link"
                      variant="link"
                      onClick={(e) => {
                        affiliatedDoctorsHandler(item.FacilityId);
                      }}
                    >
                      {t('find_provider.show_affiliated_doctors')}
                    </GenericButton>
                  </Col>
                ))
              ) : (
                <Col sm={6} className="mt-3">
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row className="m-0 p-0 pb-4">
          <Col sm={12} className="p-0">
            <p className="w-100 primary-text paragraph-font provider-affiliation-sub-heading mb-0">
              {t('find_provider.medical_group')}
            </p>
            <Row>
              {medicalGroups && medicalGroups.length ? (
                medicalGroups.map((item, index) => (
                  <Col sm={6} className="mt-3" key={index}>
                    <p className="provider-details-sub-heading">
                      {item.FacilityName}
                    </p>
                    <p className="provider-details-data-secondary">
                      <span className="provider-details-data">
                        {item.AddressLine1 && item.AddressLine1 + ', '}
                        {item.AddressLine2 && item.AddressLine2 + ', '}
                        {item.AddressLine3 && item.AddressLine3 + ', '}
                        {item.City && item.City + ', '} <br />
                        {item.County && item.County + ', '}
                        {item.State && item.State + ', '}
                        {item.PostalCode && item.PostalCode} |{' '}
                      </span>
                    </p>
                    <GenericButton
                      className=" p-0 m-0 paragraph-font secondary-2 provider-location-link"
                      variant="link"
                      onClick={(e) => {
                        affiliatedDoctorsHandler(item.FacilityId);
                      }}
                    >
                      {t('find_provider.show_affiliated_doctors')}
                    </GenericButton>
                  </Col>
                ))
              ) : (
                <Col sm={6} className="mt-3">
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </div>
      <div className="provider-facilities-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.awards_and_recognitions')}
          </p>
          {doctorDetails.AwardsAndRecognition ? (
            <p className="provider-details-data">
              {doctorDetails.AwardsAndRecognition}
            </p>
          ) : (
            <p className="no-data">{t('find_provider.data_not_available')}</p>
          )}
        </Row>
      </div>
    </>
  );
};
export default AffiliationsAwardsAccordion;
